export default "__VITE_ASSET__B5jS_PXy__"